<template>
  <transition appear name="fade">
    <div id="confirm-dialog" class="dialog" v-show="confirmVisible">
      <!-- confirm -->
      <div v-if="props.type === 'confirm'" class="dialog-box">
        <div v-if="!props.hideClose" class="dialog-cancel" @click="cancel">
          <i class="bi bi-x-circle-fill"></i>
        </div>
        <slot name="title">
          <div class="d-flex">
            <img v-if="props.image" :src="props.image" alt="" class="dialog-title-image" />
            <p class="dialog-title">{{ props.title }}</p>
          </div>
        </slot>
        <slot name="body">
          <div class="dialog-body" v-html="props.content"></div>
        </slot>
        <slot name="footer">
          <div class="button-wrap">
            <cus-button
              v-if="!props.hideCancelButton"
              :text="props.moreConfirm ? props.confirm2Text : props.cancelText"
              :color="props.moreConfirm ? props.confirm2Color || 'white' : props.cancelColor || 'white'"
              :width="30"
              @click="handleConfirmClick"
            ></cus-button>
            <cus-button
              :text="props.confirmText"
              :color="props.confirmColor || 'red'"
              :width="30"
              @click="confirm"
            ></cus-button>
          </div>
        </slot>
      </div>
      <!-- message -->
      <div v-if="props.type === 'message'" class="dialog-box">
        <div v-if="!props.hideClose" class="dialog-cancel" @click="handleMessageClick('icon')">
          <i class="bi bi-x-circle-fill"></i>
        </div>
        <slot name="title">
          <div class="d-flex">
            <img v-if="props.image" :src="props.image" alt="" class="dialog-title-image" />
            <img v-else src="@/assets/images/icon-notice.png" alt="" class="dialog-title-image" />
            <p class="dialog-title">{{ props.title }}</p>
          </div>
        </slot>
        <slot name="body">
          <div class="dialog-body" v-html="props.content"></div>
        </slot>
        <slot name="footer">
          <div class="button-wrap">
            <p v-if="getIsTestMode" class="test-mode">**目前為練習模式**</p>
            <cus-button
              :text="props.confirmText"
              :color="props.confirmColor || 'blue'"
              :width="30"
              @click="handleMessageClick('button')"
            ></cus-button>
          </div>
        </slot>
      </div>
    </div>
  </transition>
</template>
<script>
import store from '@/store';
import CusButton from '@/library/CusButton.vue';
export default {
  name: 'cus-confirm',
  components: { CusButton },
  data() {
    return {
      confirmVisible: true,
      props: {
        type: '',
        title: '',
        content: '',
        image: '',
        cancelText: '取消',
        cancelColor: '',
        confirmText: '確定',
        confirmColor: '',
        confirm2Color: '',
        moreConfirm: false, //true為關掉預設的取消按鈕(return promise reject)，改為return promise resolve(按鈕文字)
        hideClose: false, //要不要隱藏叉叉關閉按鈕
        hideCancelButton: false, //true為關掉confirm的取消按鈕
        distinguishClose: false, //true為區分message的關閉鈕和叉叉
      },
    };
  },
  computed: {
    getIsTestMode() {
      return store.getters['system/getIsTestMode'];
    },
  },
  methods: {
    handleConfirmClick() {
      if (this.props.moreConfirm) {
        this.confirm2();
      }
      else {
        this.cancel();
      }
    },
    handleMessageClick(type) {
      switch (type) {
        case 'icon':
          if (this.props.distinguishClose) this.cancel();
          else this.close();
          break;
        case 'button':
          if (this.props.distinguishClose) this.confirm();
          else this.close();
          break;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog {
  @include confirm-basic;
}
.test-mode {
  position: absolute;
  left: 0;
  bottom: 0;
  color: $color-red;
  font-size: 1.8rem;
}
.button-wrap {
  display: flex;
  justify-content: center;

  :deep(.cus-button-wrap) {
    min-height: auto;
  }
}
</style>
